import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionIndExp = (props) => {
  return (
    <Hoc>
      

      {/* <CvItem date="Aug 2020" imgSrc="">
        <CvItemDesc descBold="Method Architects Website" />
        <CvItemDetail primary bold>
          <a href="www.method.ir" target="_blank">
            www.method.ir
          </a>
        </CvItemDetail>
        <CvItemDetail> React Js ,Javascript, CSS</CvItemDetail>
      </CvItem> */}

      <CvItem date="May 2020" imgSrc="">
        <CvItemDesc descBold="Online CV" descNormal="" descComment="" />
        <CvItemDetail primary bold>
          {/* <a href="http://www.cv.vahidghodsi.com" target="_blank"> */}
            www.cv.vahidghodsi.com
          {/* </a> */}
        </CvItemDetail>
        <CvItemDetail> React Js ,Javascript, CSS</CvItemDetail>
      </CvItem>

      <CvItem date="Apr 2020" imgSrc="">
        <CvItemDesc descBold="Babak Toosipour Architects Website" />
        <CvItemDetail primary bold>
          <a href="http://www.babakToosipour.com" target="_blank">
            www.babakToosipour.com
          </a>
        </CvItemDetail>
        <CvItemDetail> React Js ,Javascript, CSS</CvItemDetail>
      </CvItem>

      <CvItem date="Dec 2017" imgSrc="">
        <CvItemDesc
          descBold="Online Portfolio"
        />
        <CvItemDetail primary bold>
          <a href="http://www.Vahidghodsi.com" target="_blank">
            www.Vahidghodsi.com
          </a>
        </CvItemDetail>
        <CvItemDetail> HTML ,Javascript, CSS</CvItemDetail>
      </CvItem>

      <CvItem date="Dec 2016" imgSrc="">
        <CvItemDesc
          descBold="http://www.method.ir"
        />
        <CvItemDetail primary bold>
          <a href="http://www.method.ir" target="_blank">
          {/* www.method.ir - ARCHIVED */}
          www.method.ir 
          </a>
        </CvItemDetail>
        <CvItemDetail> Adobe Muse </CvItemDetail>
      </CvItem>

      <CvItem date="Dec 2013" imgSrc="">
        <CvItemDesc
          descBold="Online Portfolio"
        />
        <CvItemDetail primary bold>
          {/* <a href="www.Vahidghodsi.com" target="_blank"> */}
            www.Vahidghodsi.com - ARCHIVED
          {/* </a> */}
        </CvItemDetail>
        <CvItemDetail> HTML ,Adobe Flash </CvItemDetail>
      </CvItem>
    </Hoc>
  );
};

export default cvSectionIndExp;
